import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useThemeStore } from '@/stores/theme'
import { useOrganizationStore } from '@/stores/organization'
import { useFormatters } from '@/composables/useFormatters'

export function useAppShell() {
  const auth = useAuthStore()
  const theme = useThemeStore()
  const orgStore = useOrganizationStore()
  const formatters = useFormatters()

  const user = computed(() => auth.user)
  const currentOrg = computed(() => orgStore.currentOrganization)
  const isDark = computed(() => theme.currentTheme === 'dark')

  const initials = computed(() => {
    const { first_name, last_name, email } = user.value?.attributes || {}
    if (first_name && last_name) {
      return `${first_name.charAt(0)}${last_name.charAt(0)}`.toUpperCase()
    }
    return email?.charAt(0).toUpperCase() || 'U'
  })

  const toggleTheme = () => {
    theme.toggleTheme()
  }

  return {
    user,
    currentOrg,
    initials,
    isDark,
    toggleTheme,
    ...formatters
  }
}
